import { Navigate, Outlet } from 'react-router-dom';
const StudentAuth = ()=>{
    const role = JSON.parse(localStorage.getItem('user_role'))
    return role === 3 ? <Outlet/>:<Navigate to='/'/>
}
export default StudentAuth;